module.exports = __webpack_public_path__ + "media/images/emoticons/music-c7fafe9341a0d2db1ebd9dda0797846e.gif";